import {
    TOOL_LOGIN_CONTEXT,
    TOOL_LOGIN_STEPS
} from "@omni/services/tracking/trackers/tools/login/config";
import * as ToolsStepTracker from "@omni/services/tracking/trackers/tools/toolStep.tracker";
import { createUserId } from "@omni/services/tracking/trackers/utils";
import { StepVariables } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

const trackStart = (toolStepVariables: StepVariables) => () => {
    ToolsStepTracker.track(toolStepVariables, TOOL_LOGIN_CONTEXT);
};

const trackSubmit =
    (toolStepVariables: StepVariables) => (loginResult?: { email: string }) => {
        if (!loginResult) return;

        const customerId = createUserId(loginResult.email);
        const step: StepVariables = {
            ...toolStepVariables,
            result: {
                customerid: customerId
            }
        };

        ToolsStepTracker.trackSubmit(step, TOOL_LOGIN_CONTEXT);
    };

export default {
    trackStartCheckout: trackStart(TOOL_LOGIN_STEPS.startCheckout),
    trackStartCustomer: trackStart(TOOL_LOGIN_STEPS.startCustomer),
    trackSubmitCheckout: trackSubmit(TOOL_LOGIN_STEPS.submitCheckout),
    trackSubmitCustomer: trackSubmit(TOOL_LOGIN_STEPS.submitCustomer)
};
